export const programsData = [
  {
    
    
    heading : "Technical",
    details: "Embracing innovation through coding and algorithms, we dive deep into the world of technology to pioneer solutions that redefine possibilities.",
    
    
  },
  {
    
    heading: "Management",
    details: "Navigating the path from vision to reality, our management domain orchestrates strategies that drive Mozilla Firefox's growth and impact.",
  },
  {
    
    
    heading: "Design",
    details:" Merging aesthetics with functionality, our design realm shapes seamless digital experiences, weaving beauty and usability into every interaction.",
  },
  {
    
    heading: "Editorial",
    details: " We craft narratives that illuminate Mozilla Firefox's journey, sharing insights, analyses, and stories that captivate and inform.",
  },
  {
    
    heading: "Media",
    details:"Through captivating visuals and compelling content, our media domain chronicles Mozilla Firefox's adventures, sharing its essence with the world.",

  },
  
    
  
];



